// extracted by mini-css-extract-plugin
export default {"uploadFile":"upload-file_uploadFile__A+Llg","description":"upload-file_description__Vpxh1","descriptionIcon":"upload-file_descriptionIcon__xG4-h"};